export var DisputeStatus = ['Waiting', 'Appealable', 'Solved'];